<script lang="ts">
	import { routeToDeviceSettings } from 'src/stores/ui/route-to-device-settings';
	import type { CloudRecording } from '../types/cloud-recordings';
	import { onMount } from 'svelte';
	import { getCloudRecordings } from 'src/services/cam-cloud/recordings';
	import { Container, Text, Loader, Stack } from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';
	import RecordingsListItem from './RecordingsTab/RecordingsListItem.svelte';
	import NoResults from './RecordingsTab/NoResults.svelte';
	import { camera_previews } from 'src/stores/features/cameras/previews';

	export let deviceId: string;

	const RECORDINGS_LIMIT = 3;

	let recordings: CloudRecording[] = [];
	let isLoading = true;

	$: devicePreview = $camera_previews[deviceId];
	$: if (devicePreview) loadRecordings();

	const loadRecordings = async () => {
		try {
			const result = await getCloudRecordings(deviceId, { limit: RECORDINGS_LIMIT, offset: 0 });
			recordings = result.items as CloudRecording[];
		} catch (error) {
			console.log('Failed to load recordings', error);
		} finally {
			isLoading = false;
		}
	};

	const navigateToSetting = (setting, subSetting, params) => {
		routeToDeviceSettings.setTarget(deviceId, setting, subSetting, params);
	};

	const handleSelect = (event) => {
		const recording = event.detail;
		navigateToSetting('camera_recordings', 'view', recording);
	};

	onMount(loadRecordings);
</script>

<Text styleType="body" class="text-bold mt-m"
	>{$format('last_recordings_title', { default: 'Last Events' })}</Text
>
{#if isLoading}
	<div class="d-flex justify-content-center width-full p-m">
		<Loader />
	</div>
{:else if recordings.length > 0}
	<Stack gap="s">
		{#each recordings as recording}
			<RecordingsListItem {recording} selected={false} variant="simple" on:select={handleSelect} />
		{/each}
	</Stack>
{:else}
	<Container class="pb-l">
		<NoResults />
	</Container>
{/if}
